module.exports = __webpack_public_path__ + "img/e73855f5c628a4f1fbd4b615c956d64c.png";